import { VALID_PAGE_TRANSITION_MAP } from "@/consts/ValidPageTransitionConst";

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) {
    return;
  }

  const validMapping = VALID_PAGE_TRANSITION_MAP.find(mapping => mapping.to === to.path);
  if (validMapping) {
    if (!from ||
        from.path === undefined ||
        from.path === null ||
        from.path !== validMapping.from) {
      return navigateTo(validMapping.redirectTo);
    }
  }
})
